import NoSubscriptionView from './NoSubscriptionView';

export default NoSubscriptionView;
